import React from "react";
import { AiOutlineInstagram } from "react-icons/ai";

function Footer() {
  return (
    <div className="container">
      <p className="text-center p-12">Made With 🖤 By Luthfi Ahmad</p>
    </div>
  );
}

export default Footer;
